<section
  class="form-section"
  #header
  [ngClass]="
    field?.fieldGroup?.length === 1 && !isMobile ? 'form-section-start' : ''
  "
>
  <div class="form-header">
    <div class="header-img" *ngIf="to?.icon">
      <img
        class="svg-img"
        [src]="to?.icon"
        alt="Question Image"
        *ngIf="isValidUrl(to?.icon)"
      />
      <div
        class="svg-img"
        [ngClass]="
          field?.fieldGroup?.length === 1 && !isMobile ? 'svg-img-start' : ''
        "
        *ngIf="!isValidUrl(to?.icon)"
        alt="Question Image"
        [innerHTML]="to?.icon | safe: 'html'"
      ></div>
    </div>
    <div
      class="header-content"
      [ngClass]="{
        'no-padding': !to?.image && !to?.imageUrl
      }"
    >
      <h2 class="question-title text-left">
        {{ to?.label }}
        <span *ngIf="to?.required" class="required-indicator">*</span>
      </h2>
      <h4 class="question-subtitle">{{ to?.description }}</h4>
    </div>
  </div>
</section>
<section class="form-field-section take-all-space" *ngIf="!isClosed">
  <ng-container #fieldComponent></ng-container>
</section>
